import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { LayoutService } from '../../layout/service/layout.service';

export function toastInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const layoutService = inject(LayoutService);

  // Check for custom header to skip toast
  const skipToast = req.headers.get('X-Skip-Toast') === 'true';

  return next(req).pipe(
    tap((event) => {
      //   if (
      //     event instanceof HttpResponse &&
      //     (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE') &&
      //     !skipToast
      //   ) {
      //     const responseBody = event.body as any;
      //     layoutService.notifyToaster.next({
      //       text: responseBody?.message || 'Operation successful',
      //       type: 'success',
      //     });
      //   }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status) {
        layoutService.notifyToaster.next({
          text: error.error?.message || error.message || 'An error occurred',
          type: 'error',
        });
      }
      return throwError(() => error);
    })
  );
}
